import "../../styles/iosSpinner.css"
import { motion } from "framer-motion"
import type { CSSProperties } from "react"
import { colors } from "../../services/config/colors"

export interface IosSpinnerProps {
  visible: boolean
  absolutePositioned?: boolean
  style?: CSSProperties
}

export const IosSpinner = ({
  visible,
  absolutePositioned,
  style,
}: IosSpinnerProps) => {
  return visible ? (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.2,
      }}
      className="iosSpinner"
      style={{
        ...(absolutePositioned
          ? {
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              margin: "auto",
            }
          : {}),
        backgroundColor: colors.backgroundWhite,
        border: `3px solid ${colors.strokeLight}`,
        ...style,
      }}
    >
      {Array(12)
        .fill("")
        .map((_, index) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: array never changes
            key={index}
            className={`iosBar iosBar${index + 1}`}
            style={{ backgroundColor: colors.primary }}
          />
        ))}
    </motion.div>
  ) : absolutePositioned ? null : (
    <div className="iosPlaceholder" style={style} />
  )
}
